import React from 'react';

import {fa1, fa2, fa3, fa4, fa5
} from '../../../../../images/index.js'
export const features = [
  {
    title: 'Earnings Overview',
    description: 'Monitor total revenue, sales performance, and daily growth instantly.',
    icon: fa5,
    highlighted: false,
  },
  {
    title: 'Returns & Refund Tracking',
    description: 'Track product returns and refunds while understanding their direct impact on profitability.',
    icon: fa1,
    highlighted: true,
  },
  {
    title: 'Live Profit Calculator',
    description: 'Automatically calculates net profit or loss after accounting for fees, taxes, and expenses - updated in real time.',
    icon: fa2,
    highlighted: false,
  },
  {
    title: 'Real-Time Data Sync',
    description: 'Your dashboard continuously syncs with live data from your store or enterprise system.',
    icon: fa3,
    highlighted: false,
  },
  {
    title: 'Easy to Use Interface',
    description: 'No complicated tools - just a simple, responsive, and intuitive design.',
    icon: fa4,
    highlighted: false,
  },
];



